import {
    apiEndpoint, BACKEND,
} from '../utils/api';

export const backendEndpoint = apiEndpoint({
    api: BACKEND,
    endpoint: 'auth/user',
});

export async function isLoggedIn() {
    return backendEndpoint.get();
}
